import React, { Component } from 'react';
import { Table, Form, FormGroup, Label, Input, Button, Badge, Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback } from 'reactstrap';
import Switch from 'react-switch';
import LoadingSpin from "react-loading-spin";
import TooltipItem from '../../tools/TooltipItem';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { connect } from 'react-redux';

class Projections extends Component {
    //Unlike Scheduling, Projections only has one component. An attmept was made at one point to include a child component for each row, but that created more problems than it solved. You may
    //see relics of this attempt in places, but I've tried to remove all the ones I've found
    constructor(props) {
        super(props);
        this.state = {
            returnable: this.props.reduxData.userInfo,
            showPage: false,
            //departmentFilter: [",", "."],
            departmentFilter: [],
            //ac_years: [",", "."],
            ac_years: [],
            //instructorList: [",", "."],
            instructorList: [],
            activeInstructor: "",
            //subtypeFilter: [",", "."],
            subtypeFilter: [],
            //prefixFilter: [",", "."],
            prefixFilter: [],
            filterSwitch: true,
            activeYear: "",
            //projectionData: [",", "."],
            projectionData: [],
            cloneModalStatus: false,
            currentFilter: [],
            isLoading: false,
            openTermStatus: false,
            openTermYear: "",
            needToSelectTeacher: false,
            deleteSectionModal: false,
            deleteSectionText: "",
            deleteSectionButtonVisible: false,
            deleteSectionData: [],
            faultyInstructorModal: false,
            currYearTermsPerm: [],
            dictionaryModal: false,
            subtypeDictionary: []
        }
        this.getFilter();
        this.maintainList();
        this.getSubtypeDict();
        this.activeInactiveSwitch = this.activeInactiveSwitch.bind(this);
        this.toggleDictModal = this.toggleDictModal.bind(this);
    }

    async getUserInfo() {//This function retrieves information about the user that might be useful
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        //const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        //const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        console.log("get user info")
        this.getFilter();
        this.maintainList();
        this.getSubtypeDict();
        
        
    }

    async getFilter() {//This function retrieves the information that we will populate our filter form with. This is returned as a number of objects, and each one needs its own state value
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.userLevel
        }
        const response = await fetch('ProjFilterOptions', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json','Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            departmentFilter: data.department,
            ac_years: data.years,
            subtypeFilter: data.subtype,
            prefixFilter: data.prefix
        })
    }

    async maintainList() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.userLevel
        }
        const response = await fetch('MaintainProj', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
    }

    async getSubtypeDict() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.userLevel
        }
        const response = await fetch('GetSubtypeDict', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            subtypeDictionary: data
        })
    }

    componentDidMount() {
     
    }

    async applyFilter(e) {//This function takes the filter options the user selected and retrieves projection information on the events that fit the filter
        e.preventDefault();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const dataInput = new FormData(e.target);
        if (dataInput.get('prefix') == "DEFAULT" || dataInput.get('level') == "DEFAULT" || dataInput.getAll('subtype').join(',') == "" || dataInput.get('dept') == "DEFAULT" || dataInput.get('year') == "DEFAULT") {
            //The values in here have to be populated in order for the query to work, so we can't execute the fetch without them.
            return;
        }
        this.setState({//The procedure that handles this takes a bit of time, so we have a spinner to show the user that this is still loading
            isLoading: true,
            activeYear: dataInput.get('year')//We'll need to use this later
        })
        this.getTermPermissionValues(dataInput.get('year'));//This isn't what I mean, but we need it here too anyway, so
                                                            //I can't actually use this.state.activeYear here because this.setState is async, either. While I could put this in the this.setState callback,
                                                            //it seems unnecessary to pass this value through state before going into the parameter list when I could just pull it from the source
        let toSend = {
            userLevel: this.props.userLevel,
            prefix: dataInput.get('prefix'),
            level: dataInput.get('level'),
            subtype: dataInput.getAll('subtype').join(','),
            dept: dataInput.get('dept'),
            year: dataInput.get('year'),
            active: this.state.filterSwitch
        }
        const response = await fetch('ProjectionFilter', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            showPage: true,
            projectionData: data,
            currentFilter: toSend,
            isLoading: false
        })
        this.getInstructorsByDept(dataInput.get('dept'));
    }

    async getTermPermissionValues(year) {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.userLevel,
            year: year
        }
        const response = await fetch('GetProjYearTermsPerm', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            currYearTermsPerm: data
        })
    }

    async refreshFilter() {//This function is here for when we make an addition or subtraction on this page, and we need to see what's changed. The function redoes the filter fetch with the last
                            //filtered values
        this.setState({
            isLoading: true
        })
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const response = await fetch('ProjectionFilter', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(this.state.currentFilter)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            projectionData: data,
            isLoading: false
        })
    }

    async getInstructorsByDept(dept) {//This function takes the department that was filtered on and finds the instructors associated with that department. These instructors will be the ones
                                        //that can be projected
        let toSend = {
            userLevel: this.props.userLevel,
            dept: dept
        }
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const response = await fetch('ProjInstructors', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            instructorList: data
        })
    }

    cloneTo() {//The Clone functionality hasn't been completed yet
        this.cloneToggle();
    }

    async addProjection(teacher, term, eventpk, pk, teachList) {//This function adds a new projection: this teacher for this event in this term
        if (teacher == "") {//If we haven't decided on a teacher to project yet, let them know.
            this.setState({
                needToSelectTeacher: true
            })
            return;
        }
        if (teacher == "P000026818" &&  teachList?.length == 0) {//If the user attempts to project a placeholder into a term that already has a real instructor in it, this is not allowed.
            this.setState({
                faultyInstructorModal: true
            })
            return;
        }
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.userLevel,
            teacher: teacher,
            term: term,
            eventpk: eventpk
        }
        const response = await fetch('AddProj', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.refreshFilter();
    }

    findCharInst(str, n, pat) {//This bit of difficult to parse code is designed to find the character index of a certain string's Nth appearance. Originally we were able to use just the first 
                                //four characters to denote the prefix, but as it turns out that doesn't always work with all of our events. This is a dynamic solution. The parameters are 
                                //(input string, which instance to search for, substring to look for)
        var L = str.length, i = -1;
        while (n-- && i++ < L) {
            i = str.indexOf(pat, i);
            if (i < 0) break;
        }
        return i;
    }

    async deleteSecVerify(eventname, sec) {//A section can only be deleted if the section has no projections for it either in the future or within four years or so in the past.
                                            //This function verifies whether these criteria have been met for the section the user is attempting to delete
        let eventidPrimary = eventname.substring(0, this.findCharInst(eventname, 2, ' '));
        let subtypePrimary = eventname.substring(this.findCharInst(eventname, 2, ' ') + 1);
        let toSend = {
            userLevel: this.props.userLevel,
            eventid: eventidPrimary,
            subtype: subtypePrimary,
            section: sec
        }
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const response = await fetch('VerifySecDelete', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        if (data == true) {//This can't simply be if(data){} because data might be historical data that needs to be displayed to the user
            this.setState({
                deleteSectionData: toSend
            })
            this.removeSection();
        }
        else if (data == false) {
            this.setState({
                deleteSectionModal: true,
                deleteSectionButtonVisible: false,
                deleteSectionData: toSend,
                deleteSectionText: "This section cannot be deleted. Sections can only be deleted if there are no future projections for it and if the section has not had a projection for three years."
            })
        }
        else {
            this.setState({
                deleteSectionModal: true,
                deleteSectionButtonVisible: true,
                deleteSectionData: toSend,
                deleteSectionText: "These projections were found for this section: " + data + ". Are you sure you wish to proceed? These projections will be permanently lost."
            })
        }
    }

    async removeSection() {//This function deletes a section once it has been verified the user can and wants to
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const response = await fetch('DeleteSec', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(this.state.deleteSectionData)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            deleteSectionModal: false,
            deleteSectionButtonVisible: false
        })
        this.refreshFilter();
    }

    async addSection(eventpk, sec) {//This function adds a new section based on the section 01 the user selects
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.userLevel,
            basesectionpk: eventpk
        }
        const response = await fetch('AddSectionProj', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.refreshFilter();
    }

    setActiveInstructor(teacher) {//This function executes when an instructor to project is selected in the dropdown, which saves this instructor in state ready to project
        this.setState({
            activeInstructor: teacher.target.value,
            needToSelectTeacher: false
        })
    }

    activeInactiveSwitch() {
        this.setState({
            filterSwitch: !this.state.filterSwitch
        })
    }

    async deleteInstructor(teacher, yearterm, eventpk) {//This function deletes a projection and removes the instructor from this event's year/term
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.userLevel,
            teacher: teacher,
            term: yearterm,
            eventpk: eventpk
        }
        const response = await fetch('DeleteProj', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.refreshFilter();
    }

    cloneToggle() {//This is in preparation for the cloning functionality coming soon
        this.setState({
            cloneModalStatus: !this.state.cloneModalStatus
        })
    }

    identifyBadAddAttempt = (dataFromChild) => {//This is one of the previously mentioned relics from the attempt at using child components
        this.setState({
            needToSelectTeacher: true
        })
    }

    sectionChange = () => {
        this.refreshFilter();
    }

    finishedLoading = () => {
        this.setState({
            isLoading: false
        })
    }

    toggleDeleteModal() {
        this.setState({
            deleteSectionModal: !this.state.deleteSectionModal
        })
    }

    toggleDictModal() {
        //console.log('toggle is going')
        this.setState({
            dictionaryModal: !this.state.dictionaryModal
        })
    }

    addFaultyProf() {
        this.setState({
            faultyInstructorModal: !this.state.faultyInstructorModal
        })
    }

    pageRender() {//Once the filter is done loading the events and projections, we can turn this on now that it actually has something to display. This really helps with all the .map() functions I 
                    //need to call in here, since if they're simply hidden the .map() still tries to execute and will error out the entire page unless it has something to map through
        return (
            <div>
                <Modal toggle={this.addFaultyProf.bind(this)} isOpen={this.state.faultyInstructorModal}>
                    <ModalHeader toggle={this.addFaultyProf.bind(this)}>
                        ERROR
                    </ModalHeader>
                    <ModalBody>
                        You are attempting to project a placeholder value (Hood Faculty), but this year/term for this class already has a professor projected for it.
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.addFaultyProf.bind(this)}>OK</Button>
                    </ModalFooter>
                </Modal>
                <div className="inlineCustom">
                    <Input type='select' name='instructorChoice' id='instructorChoice' defaultValue='DEFAULT' invalid={this.state.needToSelectTeacher} onChange={this.setActiveInstructor.bind(this)} >
                        <option value='DEFAULT' disabled={true}>Select an Instructor</option>
                        {this.state.instructorList.map(teacher => (
                            <option value={teacher.pcid}>{teacher.name}</option>
                        ))}
                    </Input>
                    <FormFeedback>You need to select an instructor first</FormFeedback>
                </div>
                &emsp;&emsp;&emsp;
                <Table hover>
                    <thead>
                        <tr>
                            <th>Event</th>
                            <th>Section</th>
                            <th>Fall {this.state.activeYear - 1}</th>
                            <th>Winter {this.state.activeYear}</th>
                            <th>Spring {this.state.activeYear}</th>
                            <th>SummerI {this.state.activeYear}</th>
                            <th>SummerII {this.state.activeYear}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.projectionData.map(data => (
                            <tr>
                                <td><TooltipItem id={data.eventpk} title={data.eventtooltip.replaceAll("|", "\n")}>
                                    {data.eventtitle}</TooltipItem>
                                    &nbsp;
                                    <div className="inlineCustom" hidden={!this.state.isLoading}><LoadingSpin size="30px" primaryColor="#86d3ff" /></div>
                                </td>
                                <td>{data.eventsection}<br /><Button
                                    outline
                                    color='success'
                                    hidden={data.eventsection <= 1 && (this.state.currYearTermsPerm.fallval || this.state.currYearTermsPerm.wintval || this.state.currYearTermsPerm.sprval || this.state.currYearTermsPerm.sum1val || this.state.currYearTermsPerm.sum2val) ? false : true }
                                    onClick={() => this.addSection(data.eventpk, data.eventsection)}
                                >+</Button>
                                    <Button
                                        outline
                                        color='success'
                                        hidden={data.eventsection > 1 && (this.state.currYearTermsPerm.fallval || this.state.currYearTermsPerm.wintval || this.state.currYearTermsPerm.sprval || this.state.currYearTermsPerm.sum1val || this.state.currYearTermsPerm.sum2val) ? false : true}
                                        onClick={() => this.deleteSecVerify(data.eventtitle, data.eventsection)}
                                        size="sm">-</Button><br />
                                </td>
                                <td>{data.fallinstructors.map(teacher => (
                                    <div><Badge hidden={teacher == "" ? true : false}>{teacher}<Button close hidden={!this.state.currYearTermsPerm.fallval} onClick={() => this.deleteInstructor(teacher, "FALL " + (this.state.activeYear - 1), data.eventpk)} /></Badge><br /></div>
                                ))}<br /><Button outline color='success' hidden={!this.state.currYearTermsPerm.fallval} onClick={() => this.addProjection(this.state.activeInstructor, "FALL " + (this.state.activeYear - 1), data.eventpk, data.pk, data.fallinstructors)} size="sm">+</Button></td>
                                <td>{data.winterinstructors.map(teacher => (
                                    <div><Badge hidden={teacher == "" ? true : false}>{teacher}<Button close hidden={!this.state.currYearTermsPerm.wintval} onClick={() => this.deleteInstructor(teacher, "WINTER " + this.state.activeYear, data.eventpk)} /></Badge><br /></div>
                                ))}<br /><Button outline color='success' hidden={!this.state.currYearTermsPerm.wintval} onClick={() => this.addProjection(this.state.activeInstructor, "WINTER " + this.state.activeYear, data.eventpk, data.pk, data.winterinstructors)} size="sm">+</Button></td>
                                <td>{data.springinstructors.map(teacher => (
                                    <div><Badge hidden={teacher == "" ? true : false}>{teacher}<Button close hidden={!this.state.currYearTermsPerm.sprval} onClick={() => this.deleteInstructor(teacher, "SPRING " + this.state.activeYear, data.eventpk)} /></Badge><br /></div>
                                ))}<br /><Button outline color='success' hidden={!this.state.currYearTermsPerm.sprval} onClick={() => this.addProjection(this.state.activeInstructor, "SPRING " + this.state.activeYear, data.eventpk, data.pk, data.springinstructors)} size="sm">+</Button></td>
                                <td>{data.summer1instructors.map(teacher => (
                                    <div><Badge hidden={teacher == "" ? true : false}>{teacher}<Button close hidden={!this.state.currYearTermsPerm.sum1val} onClick={() => this.deleteInstructor(teacher, "SUMMERI " + this.state.activeYear, data.eventpk)} /></Badge><br /></div>
                                ))}<br /><Button outline color='success' hidden={!this.state.currYearTermsPerm.sum1val} onClick={() => this.addProjection(this.state.activeInstructor, "SUMMERI " + this.state.activeYear, data.eventpk, data.pk, data.summer1instructors)} size="sm">+</Button></td>
                                <td>{data.summer2instructors.map(teacher => (
                                    <div><Badge hidden={teacher == "" ? true : false}>{teacher}<Button close hidden={!this.state.currYearTermsPerm.sum2val} onClick={() => this.deleteInstructor(teacher, "SUMMERII " + this.state.activeYear, data.eventpk)} /></Badge><br /></div>
                                ))}<br /><Button outline color='success' hidden={!this.state.currYearTermsPerm.sum2val} onClick={() => this.addProjection(this.state.activeInstructor, "SUMMERII " + this.state.activeYear, data.eventpk, data.pk, data.summer2instructors)} size="sm">+</Button></td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
            );
    }

    render() {//The actual render() function is primarily handling the form and the modal for deleting a section
        let displayPage = <div></div>
        if (this.state.showPage == true) displayPage = this.pageRender();
        return (
            <div>
                <Modal isOpen={this.state.deleteSectionModal} toggle={this.toggleDeleteModal.bind(this)}>
                    <ModalHeader toggle={this.toggleDeleteModal.bind(this)}>
                        ALERT
                    </ModalHeader>
                    <ModalBody>
                        {this.state.deleteSectionText}
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.removeSection.bind(this)} hidden={!this.state.deleteSectionButtonVisible} color="primary">Delete</Button>
                        <Button onClick={this.toggleDeleteModal.bind(this)}>Exit</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.dictionaryModal} toggle={this.toggleDictModal} className="dictionaryModal">
                    <ModalHeader toggle={this.toggleDictModal}>
                        Subtype Legend
                    </ModalHeader>
                    <ModalBody>
                        <ul>
                        {this.state.subtypeDictionary.map(item => (
                            <li>{item.code} - {item.name}</li>
                        ))}
                        </ul>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.toggleDictModal}>OK</Button>
                    </ModalFooter>
                </Modal>
                {/*<Button onClick={this.toggleDictModal}>test</Button>*/}
                <Form inline className='d-flex' onSubmit={this.applyFilter.bind(this)} >
                    <FormGroup>
                        <Label>Class Prefix<br /><div style={{ fontSize: 10, color: '#b22222' }}>Please note the broader your filter is,</div></Label>
                        <Input type='select' name='prefix' id='prefix'  defaultValue='DEFAULT'>
                            <option value='DEFAULT' disabled={true}>Select</option>
                            <option value='%'>-ALL-</option>{/*This is here because it needs to be at the top of the list and getting that to be displayed properly when in this.state.prefixFilter was annoying*/ }
                            {this.state.prefixFilter.map(prefix => (
                                <option>{prefix}</option>
                                ))}
                        </Input>
                    </FormGroup>
                    &nbsp;
                    <FormGroup>
                        <Label>Class Level<br /><div style={{ fontSize: 10, color: '#b22222' }}>the longer the search will take</div></Label>
                        <Input type='select' name='level' id='level' defaultValue='DEFAULT'>
                            <option value='DEFAULT' disabled={true}>Select</option>
                            <option value='%'>-ALL-</option>
                            <option value='% 1%'>100</option>
                            <option value='% 2%'>200</option>
                            <option value='% 3%'>300</option>
                            <option value='% 4%'>400</option>
                            <option value='% 5%'>500</option>
                            <option value='% 6%'>600</option>
                        </Input>
                    </FormGroup>
                    &nbsp;
                    <FormGroup>
                        <Label>Subtype <AiOutlineInfoCircle onClick={this.toggleDictModal} /><br /><div style={{ fontSize: 10 }}>(Hold CTRL for multi-select)</div></Label>
                        <Input type='select' name='subtype' id='subtype' multiple>
                            <option value='%'>-ALL-</option>
                            {this.state.subtypeFilter.map(data => (
                                <option>{data}</option>
                            ))}
                        </Input>
                    </FormGroup>
                    &nbsp;
                    <FormGroup>
                        <Label>Department<p /></Label>
                        <Input type='select' name='dept' id='dept' defaultValue='DEFAULT'>
                            <option value='DEFAULT' disabled={true}>Select</option>
                            {this.state.departmentFilter.map(dept => (
                                <option value={dept.codekey}>{dept.deptname}</option> 
                                ))}
                        </Input>
                    </FormGroup>
                    &nbsp;
                    <FormGroup>
                        <Label>Academic Year<p /></Label>
                        <Input type='select' name='year' id='year' defaultValue='DEFAULT'>
                            <option value='DEFAULT' disabled={true}>Select</option>
                            {this.state.ac_years.map(year => (
                                <option value={year}>{year - 1 + '-' + year}</option>
                            ))}
                        </Input>
                    </FormGroup>
                    &nbsp; &nbsp; &nbsp;
                    <FormGroup>
                        <Label>Inactive/Active</Label>
                        <br /><br />
                        <Switch checked={this.state.filterSwitch} onChange={this.activeInactiveSwitch} uncheckedIcon={false} checkedIcon={false} id='active' name='active' onColor="#86d3ff" handleDiameter={20} />
                    </FormGroup>
                    &nbsp;
                    <Button type='submit' outline color='success' size="sm">Go</Button>
                    &nbsp;&nbsp;
                    <div className="inlineCustom" hidden={!this.state.isLoading}><LoadingSpin size="30px" primaryColor="#86d3ff" /></div>
                </Form>
                <br />
                {displayPage}
            </div>
        );
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(Projections);